import { render, staticRenderFns } from "./IdentificationPage.vue?vue&type=template&id=e6e2e39c&"
import script from "./IdentificationPage.vue?vue&type=script&lang=js&"
export * from "./IdentificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports